export default function () {
    if (!document.querySelector('.glide--big-gallery') && !document.querySelector('.glide--stage')) {
        return;
    }

    const options = {
        type: 'carousel',
        startAt: 0,
        perView: 1,
        gap: 0,
        autoplay: 5000,
        animationDuration: 0,
        rewindDuration: 0,
    };

    const glides = document.querySelectorAll('.glide');
    for (let i = 0; i < glides.length; i += 1) {
        new Glide(glides[i], options).mount();
    }
}
